/**
 * Lifecycle of an assignment group. primary owns this vocabulary — its
 * `/flow/data-access/assignment-groups/:id` endpoint serves only `Active` groups. Flow references
 * it when resolving the group a task is assigned to.
 */
export var AssignmentGroupState;
(function (AssignmentGroupState) {
    AssignmentGroupState["Active"] = "Active";
    AssignmentGroupState["SoftDeleted"] = "SoftDeleted";
})(AssignmentGroupState || (AssignmentGroupState = {}));
//# sourceMappingURL=state.js.map